<div class="arvore">
  <div *ngIf="isLoading" style="min-height: 420px" class="d-flex flex-column justify-content-center align-items-center">
    <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    <span class="mt-3" style="font-size: 14px;">Carregando helpers. Aguarde...</span>
  </div>
  <mat-tree #tree [hidden]="isLoading" [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree">
    <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
      <li class="mat-tree-node">
        <button mat-icon-button disabled></button>
        <span [class.active]="node === activeMessage" (click)="activeMessage = node; editHelper(node)">{{ node.nome }}</span>
      </li>
    </mat-tree-node>
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
      <li>
        <div class="mat-tree-node">
          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.nome">
            <mat-icon class="mat-icon-rtl-mirror">
              {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
            </mat-icon>
          </button>
          <span>{{ node.nome }}</span>
        </div>
        <ul [class.start-collapsed]="!treeControl.isExpanded(node)">
          <ng-container matTreeNodeOutlet></ng-container>
        </ul>
      </li>
    </mat-nested-tree-node>
  </mat-tree>
</div>
